'use client';

import React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import { MdSearch } from 'react-icons/md';
import { useTekstClient } from 'hooks/useTekstClient';
import styles from './AddOnsEmptyState.module.scss';

export default function AddOnsEmptyState({ hasActiveFilters = false }) {
    const { tekst } = useTekstClient();
    const pathname = usePathname();
    const title = hasActiveFilters
        ? tekst('mkgeu:mkgaddons:emptystate:title:nofiltermatch')
        : tekst('mkgeu:mkgaddons:emptystate:title:noaddonsavailable');
    const message = hasActiveFilters
        ? tekst('mkgeu:mkgaddons:emptystate:message:adjustsearch')
        : tekst('mkgeu:mkgaddons:emptystate:message:checkbacklater');

    return (
        <div className={styles.emptyState}>
            <div className={styles.emptyStateIcon} aria-hidden="true">
                <MdSearch size={64} />
            </div>
            <h2 className={styles.emptyStateTitle}>{title}</h2>
            <p className={styles.emptyStateMessage}>{message}</p>
            {hasActiveFilters && (
                <Link
                    href={pathname}
                    className={styles.emptyStateLink}
                    prefetch={false}
                    scroll={false}
                >
                    {tekst('mkgeu:mkgaddons:emptystate:link:clearfiltersandsearch')}
                </Link>
            )}
        </div>
    );
}
